import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const chat: ThemeUICSSObject = {
  /* PREPEND HERE */
  height: 'calc(100vh - 300px)',
  minHeight: '25vh',
  width: '100%',
  flexShrink: 1,
  // border: '1px solid',
  // borderColor: 'palette.border.section',

  '.autoscrollContainer': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 3,
    p: 3,
  },

  '.history__message': {
    borderRadius: '2px',
    px: 4,
    py: 5,
    maxWidth: '80%',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',

    '&.user': {
      borderRadius: '20px 2px 20px 20px',
      backgroundColor: 'rgb(108 166 203)', //rgb(117 163 192)', //rgb(92, 143, 174)',
      color: 'white',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(113 145 193)',
      alignSelf: 'end',
    },
    '&.system': {
      borderRadius: '2px 20px 20px 20px',
      backgroundColor: '#00bcff14',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.warning': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#ffff0024',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.error': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#fd84212b',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.information': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#00bcff14', //'#2222cc2b',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px',
      border: '1px solid rgb(0 28 38 / 18%)',
    },

    '&.multipleChoice': {
      p: 0,
    },

    '.multipleChoiceMessage:not(.customRenderer)': {
      background: '#0178f52b',
      td: { textAlign: 'center' },
      th: { backgroundColor: '#14597bab' },
      table: { borderBottom: '1px solid' },
      'button.multipleChoice__option': {
        width: '-webkit-fill-available',
        backgroundColor: '#14597bab',
      },
      '.taskInfoDiv': {
        display: 'flex',
        justifyContent: 'space-evenly',
      },
    },

    '.multipleChoiceMessage.customRenderer': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,

      '& > p': {
        background: '#0178f52b',
        p: 3,
      },

      '.selection__keyHandler': {
        m: 0,
        padding: 3,
        border: '1px solid',
        borderColor: 'palette.border.article',
        borderRadius: 'panel',
      },
    },
  },

  '.help__container': {
    borderRadius: '2px 20px 20px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  '.functionHelp': {
    borderRadius: '2px 20px 20px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.functionHelp__description, .functionHelp__usage': {
      pl: 5,
    },
    '.history__message': {
      wordWrap: 'break-word',
      overflow: 'hidden',
      whiteSpace: 'break-spaces',
    },
  },
};
